import { render } from "./DynamicToogleButton.vue?vue&type=template&id=7e333d55&ts=true"
import script from "./DynamicToogleButton.vue?vue&type=script&lang=ts"
export * from "./DynamicToogleButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicToogleButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e333d55"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e333d55', __exports__)) {
    api.reload('7e333d55', __exports__)
  }
  
  module.hot.accept("./DynamicToogleButton.vue?vue&type=template&id=7e333d55&ts=true", () => {
    api.rerender('7e333d55', render)
  })

}


export default __exports__